import Axios from "axios";

Axios.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
Axios.defaults.headers.common['X-Frame-Options'] = 'DENY';  // Options: 'DENY', 'SAMEORIGIN', or 'ALLOW-FROM origin'
Axios.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none';"; 
Axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';  // Anti-MIME-Sniffing header
Axios.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';  // Denies all attempts to load the page in an iframe
Axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';

Axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const isEmployee = window.location.pathname.split("/").includes("employee");
    if (err && err.response && err.response.data && err.response.data.Errors) {
      for (const error of err.response.data.Errors) {
        if (error.message.includes("InvalidAccessTokenException")) {
          localStorage.clear();
          sessionStorage.clear()
          window.location.href ="/digit-ui/citizen" +
            `?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
        }
      }
    }
    throw err;
  }
);

const requestInfo = () => ({
  authToken: Digit.UserService.getUser().access_token || null,
});

const authHeaders = () => ({
  "auth-token": Digit.UserService.getUser().access_token || null,
});

const userServiceData = () => ({ userInfo: Digit.UserService.getUser().info });

window.Digit = window.Digit || {};
window.Digit = { ...window.Digit, RequestCache: window.Digit.RequestCache || {} };
export const Request = async ({
  method = "POST",
  url,
  data = {},
  headers = {},
  useCache = false,
  params = {},
  auth,
  urlParams = {},
  userService,
  locale = true,
  authHeader = false,
  setTimeParam = true,
  userDownload = false,
  noResponseData = false,
  noRequestInfo = false,
  multipartFormData = false,
  multipartData = {}
}) => {
  if (method.toUpperCase() === "POST") {
    const ts = new Date().getTime()
    data.RequestInfo = {
      apiId: "Rainmaker",
    };
    if (auth) {
      data.RequestInfo = { ...data.RequestInfo, ...requestInfo() };
    }
    if (userService) {
      data.RequestInfo = { ...data.RequestInfo, ...userServiceData() };
    }
    if (locale) {
      data.RequestInfo = { ...data.RequestInfo, msgId: `${ts}|${Digit.StoreData.getCurrentLanguage()}` };
    }
    if (noRequestInfo) {
      delete data.RequestInfo;
    }
  }

  const headers1 = {
    "Content-Type": "application/json",
    Accept: window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")?"application/pdf,application/json":"*/*",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none';", 
     "X-Content-Type-Options": "nosniff",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  };

  if (authHeader) headers = { ...headers, ...authHeaders() };

  if (userDownload) headers = { ...headers, ...headers1 };

  let key = "";
  if (useCache) {
    key = `${method.toUpperCase()}.${url}.${btoa(escape(JSON.stringify(params, null, 0)))}.${btoa(escape(JSON.stringify(data, null, 0)))}`;
    const value = window.Digit.RequestCache[key];
    if (value) {
      return value;
    }
  } else if (setTimeParam) {
    params._ = Date.now();
  }

  let _url = url
    .split("/")
    .map((path) => {
      let key = path.split(":")[1];
      return urlParams[key] ? urlParams[key] : path;
    })
    .join("/");
  
  if (multipartFormData) {
    const multipartFormDataRes = await Axios({ method, url: _url, data: multipartData.data, params, headers: { "Content-Type": "multipart/form-data", "auth-token": Digit.UserService.getUser().access_token || null  } });
    return multipartFormDataRes;
  }

 
    /* Fix for central instance to send tenantID in all query params  */
    const tenantInfo = Digit.SessionStorage.get("userType") === "citizen" ? Digit.ULBService.getStateId():Digit.ULBService.getCurrentTenantId() || Digit.ULBService.getStateId() ;
    if ((!params["tenantId"])&&(window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE"))) {
      params["tenantId"]=tenantInfo;
    }

  const res = userDownload
    ? await Axios({ method, url: _url, data, params, headers, responseType: "arraybuffer" })
    : await Axios({ method, url: _url, data, params, headers });

  if (userDownload) return res;
  if (noResponseData) return res;
  const returnData = res.data || res.response.data || {};
  if (useCache && res.data && Object.keys(returnData).length !== 0) {
    window.Digit.RequestCache[key] = returnData;
  }
  return returnData;
};

/**
 *
 * @param {*} serviceName
 *
 * preHook:
 * ({params, data}) => ({params, data})
 *
 * postHook:
 * ({resData}) => ({resData})
 *
 */

export const ServiceRequest = async ({
  serviceName,
  method = "POST",
  url,
  data = {},
  headers = {},
  useCache = false,
  params = {},
  auth,
  userService,
}) => {
  const preHookName = `${serviceName}Pre`;
  const postHookName = `${serviceName}Post`;

  let reqParams = params;
  let reqData = data;
  if (window[preHookName] && typeof window[preHookName] === "function") {
    let preHookRes = await window[preHookName]({ params, data });
    reqParams = preHookRes.params;
    reqData = preHookRes.data;
  }
  const resData = await Request({ method, url, data: reqData, headers, useCache, params: reqParams, auth, userService });

  if (window[postHookName] && typeof window[postHookName] === "function") {
    return await window[postHookName](resData);
  }
  return resData;
};
